import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'C1',
      mockup: (
        <g id="c1" transform="translate(212.000000, 218.000000)">
          <polygon
            id="fill-c1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="56.0477109 59.1278138 49.4701583 59.1278138 49.4701583 47.2516772 36.6103516 47.2516772 36.6103516 0.93359375 12.2983398 0.93359375 0.75390625 82.6772461 9.35009766 82.6772461 9.35009766 99.7910156 69.9116211 99.7910156 69.9116211 59.1278138"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="27.2226603" y="71.1278138">
              01
            </tspan>
          </text>
          <text
            id="C1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="26.6526603" y="86.5853783">
              C1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B1',
      mockup: (
        <g id="b1" transform="translate(246.000000, 198.000000)">
          <polygon
            id="fill-b1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="22.0477109 67.2516772 2.49776302 67.2516772 2.49776302 20.8433897 1.76692384 20.8433897 1.76692384 5.35107422 0.7421875 5.35107422 0.7421875 0.952148438 39.8432617 0.952148438 39.8432617 13.0854492 36.3735352 13.0854492 36.3735352 66.1772461 22.0477109 66.1772461"
          />
          <text
            id="02"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.971058" y="31.648103">
              02
            </tspan>
          </text>
          <text
            id="B1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.191058" y="47.648103">
              B1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A5',
      mockup: (
        <g id="a5" transform="translate(207.000000, 316.000000)">
          <polygon
            id="fill-a5"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="12.0814863 38.9621857 48.2580254 38.9621857 48.2580254 24.3454023 74.9336552 24.3454023 74.9336552 1.91015625 14.4462891 1.91015625 14.4462891 0.236328125 0.630371094 0.236328125 0.630371094 31.1401367 4.85302734 31.1401367 4.85302734 30.1650391 12.0814863 30.1650391"
          />
          <text
            id="20"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.5999445" y="16.5804246">
              20
            </tspan>
          </text>
          <text
            id="A5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="22.0479445" y="32.5804246">
              A5
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C8',
      mockup: (
        <g id="c8" transform="translate(207.000000, 351.000000)">
          <path
            d="M80.1357422,0.673409461 L59.4033228,0.673409461 L59.4033228,16.2037419 L12.0814863,16.2037419 L12.0814863,12.7322558 C4.53725324,12.7322558 0.765136719,12.7322558 0.765136719,12.7322558 C0.765136719,12.7322558 0.765136719,21.7500521 0.765136719,39.7856445 L14.4438477,39.7856445 L14.4438477,75.440918 L70.5888672,75.440918 L70.5888672,27.8916016 L79.9003906,27.8916016 L80.1357422,0.673409461 Z"
            id="fill-c8"
            stroke="#000000"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <text
            id="19"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="33.2746651" y="40.04">
              19
            </tspan>
          </text>
          <text
            id="C8"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="32.7046651" y="55.440918">
              C8
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B16',
      mockup: (
        <g id="b16" transform="translate(277.000000, 351.000000)">
          <polygon
            id="fill-b16"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="48.0531665 0.673409461 48.0531665 58.592414 21.9038086 58.592414 21.9038086 71.1567383 22.9013672 71.1567383 22.9013672 75.4960938 0.397949219 75.4960938 0.397949219 28.1977539 10.1108398 28.1977539 10.1108398 6.7734375 29.3994141 6.7734375 29.3994141 0.673409461"
          />
          <text
            id="18"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="20.104" y="28.5">
              18
            </tspan>
          </text>
          <text
            id="B16"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="16.126" y="44.5">
              B16
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B5',
      mockup: (
        <g id="b5" transform="translate(324.000000, 351.000000)">
          <polygon
            id="fill-b5"
            stroke="#000000"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="56.2315241 12.9149656 29.738604 12.9149656 29.738604 4.87573471 11.4676247 4.87573471 11.4676247 0.673409461 0.931640625 0.673409461 0.931640625 58.6035156 46.2558594 58.6035156"
          />
          <text
            id="B5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.8829796" y="44.5">
              B5
            </tspan>
          </text>
          <text
            id="17"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.8044016" y="28.5">
              17
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A2',
      mockup: (
        <g id="a2" transform="translate(335.000000, 320.000000)">
          <polygon
            id="fill-a2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="59.1174684 0.795454376 0.467624679 0.795454376 0.467624679 35.8681641 18.5576172 35.8681641 18.5576172 43.9833984 44.9970703 43.9833984 49.2617188 25.6262207 55.769043 25.6262207 55.769043 26.6203613 59.1174684 26.6203613"
          />
          <text
            id="16"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="25.4339589" y="17.7422692">
              16
            </tspan>
          </text>
          <text
            id="A2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="24.8819589" y="34.6163816">
              A2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A1',
      mockup: (
        <g id="a1" transform="translate(335.000000, 284.000000)">
          <polygon
            id="fill-a1"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="59.1174684 17.9763457 53.6361746 17.9763457 53.6361746 1.71517404 53.6361746 0.253495694 0.467624679 0.253495694 0.467624679 36.7954544 59.1174684 36.7954544"
          />
          <text
            id="15"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="18.9339589" y="14.6006041">
              15
            </tspan>
          </text>
          <text
            id="A1"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="18.3819589" y="30.448346">
              A1
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B2',
      mockup: (
        <g id="b2" transform="translate(282.000000, 199.000000)">
          <polygon
            id="fill-b2"
            stroke="#000000"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="37.2064531 52.5484427 26.4265753 52.5484427 26.4265753 65.1554184 0.370605469 65.1554184 0.370605469 12.1108398 20.2094727 12.1108398 20.2094727 4.4921875 18.7885293 4.4921875 18.7885293 0.0654296875 44.652832 0.0654296875 44.652832 52.5484427"
          />
          <text
            id="03"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.1838619" y="28.6104241">
              03
            </tspan>
          </text>
          <text
            id="B2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.4038619" y="44.6104241">
              B2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B12',
      mockup: (
        <g id="b12" transform="translate(319.000000, 198.000000)">
          <polygon
            id="fill-b12"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="44.6049329 13.1695783 44.0568035 13.1695783 35.4694432 13.1695783 35.4694432 0.928022173 7.6975546 0.928022173 7.6975546 53.5484427 0.206453066 53.5484427 0.206453066 66.1554184 39.6717684 66.1554184 39.6717684 53.3657329 44.6049329 53.3657329"
          />
          <text
            id="04"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="16.6629796" y="29.5417203">
              04
            </tspan>
          </text>
          <text
            id="B12"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.6849796" y="45.5417203">
              B12
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B15a',
      mockup: (
        <g id="b15a" transform="translate(358.000000, 185.000000)">
          <polygon
            id="fill-b15a"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="48.5417343 11.3700851 35.3866292 11.3700851 35.3866292 0.224787667 5.05680348 0.224787667 5.05680348 26.1695783 5.60493286 26.1695783 5.60493286 66.3657329 0.671768442 66.3657329 0.671768442 79.1554184 17.6637792 79.1554184 17.6637792 70.0199287 48.7244441 70.0199287 48.7244441 44.6232675 48.5417343 44.6232675"
          />
          <text
            id="05"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="21.6520991" y="37.4230788">
              05
            </tspan>
          </text>
          <text
            id="B15a"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="14.4940991" y="52.8648236">
              B15a
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B15',
      mockup: (
        <g id="b15" transform="translate(450.000000, 185.000000)">
          <polygon
            id="fill-b15"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.7041135 11.3700851 30.9046202 11.3700851 30.9046202 0.224787667 0.392084732 0.224787667 0.392084732 11.3700851 1.12292391 11.3700851 1.12292391 70.0199287 45.7041135 70.0199287"
          />
          <text
            id="07"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="16.6520991" y="36.169103">
              07
            </tspan>
          </text>
          <text
            id="B15"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="12.6740991" y="51.1019128">
              B15
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B15',
      mockup: (
        <g id="b15" transform="translate(406.000000, 185.000000)">
          <polygon
            id="fill-b15"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="45.1229239 11.3700851 44.3920847 11.3700851 31.2369796 11.3700851 31.2369796 0.224787667 0.724444108 0.224787667 0.724444108 11.3700851 0.541734315 11.3700851 0.541734315 44.6232675 0.724444108 44.6232675 0.724444108 70.0199287 45.1229239 70.0199287"
          />
          <text
            id="06"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="13.922646" y="36.169103">
              06
            </tspan>
          </text>
          <text
            id="B15-Copy"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="9.94464597" y="51.1019128">
              B15
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A4',
      mockup: (
        <g id="a4" transform="translate(493.000000, 164.000000)">
          <polygon
            id="fill-a4"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="32.8512294 16.2916232 32.4858098 16.2916232 32.4858098 0.578581012 0.877015563 0.578581012 0.877015563 32.3700851 2.7041135 32.3700851 2.7041135 74.5760473 32.8512294 74.5760473"
          />
          <text
            id="08"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="10.4681225" y="33.4441183">
              08
            </tspan>
          </text>
          <text
            id="A4"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="9.91612249" y="49.71051">
              A4
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'D2',
      mockup: (
        <g id="d2" transform="translate(511.000000, 164.000000)">
          <polygon
            id="fill-d2"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="77.3379788 21.0420779 67.6543597 20.4939485 57.0571917 9.89678048 56.5090623 0.578581012 45.1810551 0.578581012 45.1810551 2.77109853 34.9493067 12.8201372 34.9493067 16.2916232 14.8512294 16.2916232 14.8512294 74.5760473 0.782575317 74.5760473 0.782575317 91.2026385 65.4618422 91.2026385 65.4618422 77.8648236 77.3379788 77.8648236"
          />
          <text
            id="09"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="34.779242" y="49.4441183">
              09
            </tspan>
          </text>
          <text
            id="D2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="33.981242" y="64.8559281">
              D2
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(507.000000, 255.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.3379788 13.1750339 69.4618422 13.1750339 69.4618422 0.202638542 0.397540275 0.202638542 0.397540275 34.9174993 81.3379788 34.9174993"
          />
          <text
            id="10"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="32.7802704" y="13.5600689">
              10
            </tspan>
          </text>
          <text
            id="B13"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="28.8022704" y="29.5600689">
              B13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(507.000000, 289.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.3379788 0.91749929 0.397540275 0.91749929 0.397540275 35.2669405 69.644552 35.2669405 69.644552 22.6599647 81.3379788 22.6599647"
          />
          <text
            id="B13-Copy"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="28.8022704" y="30.8976233">
              B13
            </tspan>
          </text>
          <text
            id="11"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="32.7802704" y="14.8976233">
              11
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B13',
      mockup: (
        <g id="b13" transform="translate(507.000000, 324.000000)">
          <polygon
            id="fill-b13"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.3379788 12.8739162 69.644552 12.8739162 69.644552 0.26694045 0.397540275 0.26694045 0.397540275 34.6163816 10.6292887 34.6163816 81.3379788 34.6163816"
          />
          <text
            id="B13-Copy-2"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="28.8022704" y="28.9006508">
              B13
            </tspan>
          </text>
          <text
            id="12"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="32.7802704" y="12.7422692">
              12
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B14a',
      mockup: (
        <g id="b14a" transform="translate(507.000000, 358.000000)">
          <polygon
            id="fill-b14a"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="81.3379788 0.616381611 0.397540275 0.616381611 0.397540275 32.4078857 11.3601279 32.4078857 11.3601279 44.466732 69.644552 44.466732 69.644552 27.657431 81.3379788 27.657431"
          />
          <text
            id="B14a"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="25.6222704" y="34.348564">
              B14a
            </tspan>
          </text>
          <text
            id="13"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="32.7802704" y="18.7345496">
              13
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'B14',
      mockup: (
        <g id="b14" transform="translate(516.000000, 402.000000)">
          <polygon
            id="fill-b14"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="60.644552 0.466732029 2.36012788 0.466732029 2.36012788 42.8554041 0.715739739 42.8554041 0.715739739 47.0577293 72.3379788 47.0577293 72.3379788 17.276033 60.644552 17.276033"
          />
          <text
            id="B14-Copy"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="19.8022704" y="36.5792046">
              B14
            </tspan>
          </text>
          <text
            id="14"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="23.7802704" y="20.440918">
              14
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <g
        id="streets"
        transform="translate(300.000000, 313.000000)"
        fill="#0B1A27"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
      >
        <text id="CLARKSON-ST">
          <tspan x="0" y="170.966278">
            CLARKSON ST
          </tspan>
        </text>
        <text
          id="SIXTH-ST"
          transform="translate(303.822589, 20.500000) rotate(-90.000000) translate(-303.822589, -20.500000) "
        >
          <tspan x="283.322589" y="24.5">
            SIXTH ST
          </tspan>
        </text>
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
      <text
        id="AMENITY-TERRACE"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
        fill="#0B1A27"
      >
        <tspan x="79.159689" y="397.5">
          AMENITY TERRACE
        </tspan>
      </text>
      <text
        id="AMENITY-TERRACE"
        fontFamily="DINOT, DIN OT"
        fontSize="10"
        fontWeight="normal"
        fill="#0B1A27"
      >
        <tspan x="386.048099" y="399.037562">
          AMENITY TERRACE
        </tspan>
      </text>
      <text
        id="LEVEL-4"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="303.972" y="597.839844">
          LEVEL 4
        </tspan>
      </text>
      <g
        id="bg-lines"
        transform="translate(38.000000, 164.000000)"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect
          id="Rectangle-path"
          strokeWidth="0.5"
          x="264.397152"
          y="113.127814"
          width="16.6265912"
          height="63.2175885"
        />
        <path
          d="M264.397152,133.591311 L281.023743,133.591311"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M264.397152,155.151066 L281.023743,155.151066"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="264.397152 162.276748 254.530823 162.276748 254.530823 128.292727"
        />
        <path
          d="M264.397152,128.292727 L254.530823,128.292727"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M244.116365,162.276748 L254.530823,162.276748"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="281.023743 176.345402 264.397152 155.151066 281.023743 133.591311 264.397152 113.127814"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="264.397152 176.345402 281.023743 155.151066 264.397152 133.591311 281.023743 113.127814"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="264.397152 113.127814 243.933655 113.127814 243.933655 176.345402 264.397152 176.345402"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="246.491592 34.9280222 246.491592 30.7256969 264.579862 30.7256969 264.579862 34.9280222"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="208.670665 34.9280222 195.33285 34.9280222 195.33285 54.8433897"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="169.570769 152.22771 169.570769 134.687569 175.052063 134.687569"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="325.056803 31.0911165 315.007765 31.0911165 315.007765 34.9280222"
        />
        <path
          d="M368.724444,21.2247877 L355.386629,21.2247877"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M412.392085,21.2247877 L399.23698,21.2247877"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M455.877016,21.2247877 L442.90462,21.2247877"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M538.644552,238.466732 L550.337979,238.466732"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M538.644552,160.26694 L550.337979,160.26694"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M550.337979,172.873916 L550.337979,147.659965"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M550.337979,255.276033 L550.337979,221.657431"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M487.48581,0.578581012 L518.181055,0.578581012"
          id="Shape"
          strokeWidth="0.3"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="356.117468 182.557535 356.117468 188.404249 453.319078 188.404249 453.319078 105.636712 351.915143 105.636712 351.915143 120.436205 350.636175 120.436205"
        />
        <path
          d="M538.461842,91.2026385 L550.337979,91.2026385"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M550.337979,104.175034 L550.337979,77.8648236"
          id="Shape"
          strokeWidth="0.5"
        />
        <rect
          id="Rectangle-path"
          strokeWidth="0.5"
          x="0.0160810125"
          y="180.365018"
          width="41.1097035"
          height="23.021434"
        />
        <path
          d="M28.5188088,191.875735 L12.6230568,191.875735"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M28.5188088,180.365018 L28.5188088,203.386452"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="447.289655 267.517589 444.914428 267.517589 433.586421 267.517589 433.586421 276.287659 403.439305 276.287659 403.439305 267.517589 389.73607 267.517589 389.73607 276.287659 361.416052 276.287659 331.817066 276.287659 331.817066 267.517589 303.862467 267.517589 303.862467 276.287659 274.263481 276.287659 274.263481 267.517589 265.493411 267.517589 265.493411 276.287659 236.077134 276.287659 236.077134 267.517589 205.381889 267.517589 205.381889 276.287659 175.052063 276.287659 175.052063 267.517589 161.531538 267.517589 161.531538 276.287659 131.201713 276.287659 131.201713 267.517589 117.863898 267.517589 117.863898 276.287659 87.5340721 276.287659 87.5340721 267.517589 74.0135473 267.517589 74.0135473 276.287659 43.6837216 276.287659 43.6837216 267.517589 30.3459067 267.517589 30.3459067 276.287659 0.0160810125 276.287659 0.0160810125 203.386452"
        />
        <rect
          id="Rectangle-path"
          strokeWidth="0.5"
          x="447.289655"
          y="243.217187"
          width="23.021434"
          height="40.9269937"
        />
        <path
          d="M458.800372,255.641453 L458.800372,271.537205"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M447.289655,255.641453 L470.311089,255.641453"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M447.289655,271.537205 L470.311089,271.537205"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M453.319078,188.404249 L453.319078,243.217187"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="172.311416 183.105665 172.311416 188.221539 41.1257845 188.221539"
        />
        <path
          d="M470.311089,280.855404 L478.71574,280.855404"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="331.817066 267.517589 332.547905 267.517589 332.547905 245.592414"
        />
        <path
          d="M287.053166,245.592414 L287.053166,276.287659"
          id="Shape"
          strokeWidth="0.5"
        />
        <path
          d="M239.54862,262.401715 L239.54862,276.287659"
          id="Shape"
          strokeWidth="0.5"
        />
        <polyline
          id="Shape"
          strokeWidth="0.5"
          points="169.570769 224.580788 158.608182 224.580788 158.608182 267.517589 161.531538 267.517589"
        />
      </g>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level4.js